import styled from '@emotion/styled';
import { CommunityBadgeIcon, PluralIcon, BrainIcon, TriviamasterIcon, DerDieDasIcon, MagnifyWordsIcon, BookIcon, ShakespeareIcon, MicrophoneBadgeIcon, CardsIcon, ClockfaceIcon, SeedlangIcon, StreakIcon } from '@seedlang/icons';
import { AppUI } from '@seedlang/state';
import { isPresent } from '@seedlang/utils';
import Badge from 'components/badge';
import BadgeShow from 'components/badge_show';
import LeagueBadgeIcon from 'components/league/league_badge_icon';
import NotificationMessage from 'components/notification/notification_message';
import Paginator from 'components/paginator';
import SiteProfileImage from 'components/site_profile_image';
import Text from 'components/text';
import UserProfileImage from 'components/user/user_profile_image';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import React from 'react';
import Link from 'components/link';

const Wrapper = styled.div`
  .seedlang-icon {
    margin-right: 10px;
    border-radius: 50%;
    border: 1px solid green;
    svg {
      width: 52px;
    }
  }
`;

const Notification = styled.div`
  background: ${props => props.background};
  display: flex;
  align-items: center;
  padding: 5px;
  font-size: 14px;
  line-height: 18px;
  border-bottom: 1px solid #CCC;
  text-align: left;
  cursor: ${props => props.cursor};
  a {
    display: flex;
    align-items: center;
    flex: 1;
    color: inherit;
    text-decoration: none;
  }
`;

const MessageWrapper = styled.div`
  flex: 1;
`;

const PaginatorWrapper = styled.div`
  padding: 0 5px 5px 5px;
`;

const StreakWrapper = styled.div`
  width: 45px;
  height: 45px;
  margin: 7px;
  background: #FFF;
  border-radius: 200px;
  border: 3px solid orange;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ImageWrapper = styled.div`
  width: 64px;
`;

const ICONS = {
  storyteller: ShakespeareIcon,
  interviewMe: MicrophoneBadgeIcon,
  deckmaster: CardsIcon,
  backInTime: ClockfaceIcon,
  storymaster: BookIcon,
  gendermaster: DerDieDasIcon,
  vocabmaster: MagnifyWordsIcon,
  brainiac: BrainIcon,
  triviamaster: TriviamasterIcon,
  pluralmaster: PluralIcon,
  community: CommunityBadgeIcon,
};

@observer
class NotificationIndex extends React.Component {
  @observable selectedBadge = null;

  badgeForNotification = (item) => {
    if (!item.badge) {
      return null;
    }
    const badgeLevel = item.badgeLevel;
    const badgeSlug = item.badgeType || item.badge.badgeSlug || item.badge.badge_slug;
    return {
      name: item.badge.name,
      description: item.badge.description,
      interpolationString: item.badge.interpolationString || item.badge.interpolation_string,
      current: badgeLevel ? item.badge.levels[badgeLevel - 1] || item.badge.current || 0 : item.badge.current || 0,
      levels: item.badge.levels,
      badgeSlug: badgeSlug,
      badgeLevel: badgeLevel,
    };
  }

  onPressNotification = (item) => {
    const badge = this.badgeForNotification(item);
    if (item.badgeType && badge) {
      this.selectedBadge = badge;
    }
  }

  renderNotificationContent(item) {
    const badge = this.badgeForNotification(item);
    return (
      <>
        <ImageWrapper>
          {
            item.badgeType && badge ? (
              <Badge
                hideInfo
                disableTooltip
                alignment='vertical'
                width='52px'
                wrapperWidth='52px'
                wrapperHeight='52px'
                bottom='-4px'
                right='-4px'
                levelIndicatorWidth='20px'
                levelIndicatorBorderWidth='2px'
                levelIndicatorFontSize='8px'
                cursor='pointer'
                name={badge.name}
                description={badge.description}
                current={badge.current}
                levels={badge.levels}
                icon={React.createElement(ICONS[badge.badgeSlug])}
              />
            ) : item.notifiableType === 'Streak' ? (
              <StreakWrapper>
                <StreakIcon
                  width='17px'
                  top='-3px'
                  full
                  hideStreakNumber
                />
              </StreakWrapper>
            ) : item.primarySender ? (
              <UserProfileImage
                clickToProfile
                user={item.primarySender}
                width={52}
                margin='0 10px 0 0'
              />
            ) : item.leagueLevel ? (
              <LeagueBadgeIcon
                leagueLevelPosition={item.leagueLevel.position}
                width='50px'
                height='50px'
                margin='-5px 0 0 0'
              />
            ) : AppUI.site.isSeedlang ? (
              <SeedlangIcon />
            ) : (
              <SiteProfileImage
                site={AppUI.site}
                width={52}
                margin='0 10px 0 0'
              />
            )
          }
        </ImageWrapper>
        <MessageWrapper>
          <NotificationMessage
            notification={item}
          />
          <Text
            italic
            color='#777'
            fontSize='13px'
          >
            {item.createdAt && item.createdAt.relativeTime}
          </Text>
        </MessageWrapper>
      </>
    );
  }

  render() {
    return (
      <Wrapper>
        {
          this.selectedBadge &&
            <BadgeShow
              badge={this.selectedBadge}
              onCloseModal={() => this.selectedBadge = null}
            />
        }
        {
          isPresent(this.props.notifications) && this.props.notifications.map(item => {
            const badge = this.badgeForNotification(item);
            return (
              <Notification
                background={item.seen ? '#FFF' : '#edf2fa'}
                cursor={item.badgeType && badge ? 'pointer' : null}
                onClick={() => this.onPressNotification(item)}
                key={item.id}
              >
                {
                  isPresent(item.notificationLink) && !item.badgeType ? (
                    <Link to={item.notificationLink}>
                      {this.renderNotificationContent(item)}
                    </Link>
                  ) : (
                    this.renderNotificationContent(item)
                  )
                }
              </Notification>
            );
          })
        }
        {
          isPresent(this.props.notifications) &&
          <PaginatorWrapper>
            <Paginator
              compact
              onClickScrollToTop
              store={this.props.store}
            />
          </PaginatorWrapper>
        }
      </Wrapper>
    );
  }
}

export default NotificationIndex;
